/** 来源：foodbuy Metric 与三家概览卡需求；label/value/suffix/detail 为基线，T11 补 tone（market StatCard）与 icon 槽（crm MetricCard）。 */
import type { ReactNode } from 'react'
import type { Tone } from './tones'

/**
 * 值的上色：默认墨色；语义色决策归应用 labels/tones（03 §3），这里只负责渲染。
 * 导出给 `MetricStrip`（LeapWorldTwin-111）复用——同一套 tone → 值上色规则，两处不许各抄一份。
 */
export const metricValueToneClasses: Record<Tone, string> = {
  neutral: 'text-[var(--color-ink)]',
  info: 'text-[var(--color-primary)]',
  success: 'text-[var(--color-success-ink)]',
  warning: 'text-[var(--color-warning-ink)]',
  danger: 'text-[var(--color-danger-ink)]'
}

export function Metric({ label, value, suffix, detail, tone = 'neutral', icon }: { label: ReactNode; value: ReactNode; suffix?: ReactNode; detail?: ReactNode; tone?: Tone; icon?: ReactNode }) {
  return (
    <div className="min-w-0 rounded-[var(--radius-lg)] border border-[var(--color-line)] bg-[var(--color-panel)] px-4 py-3 shadow-[var(--shadow-card)]">
      <p className="m-0 flex items-center gap-2 text-xs font-medium text-[var(--color-ink-secondary)]">
        {icon ? <span className="flex size-5 shrink-0 items-center justify-center [&>svg]:size-5">{icon}</span> : null}
        <span className="min-w-0 [overflow-wrap:anywhere]">{label}</span>
      </p>
      <p className={`m-0 mt-1 font-[family-name:var(--font-num)] text-[length:var(--text-metric)] leading-tight font-semibold tracking-[-0.02em] tabular-nums [overflow-wrap:anywhere] ${metricValueToneClasses[tone]}`}>
        {value}
        {suffix ? <span className="ml-1 font-sans text-sm font-medium tracking-normal text-[var(--color-ink-secondary)]">{suffix}</span> : null}
      </p>
      {detail ? <p className="m-0 mt-1 text-[length:var(--text-caption)] leading-5 text-[var(--color-ink-secondary)] [overflow-wrap:anywhere]">{detail}</p> : null}
    </div>
  )
}
